<template>
  <div class="header-left d-flex align-items-end pt-2" data-cy="tt-calendar-header-left">
    <div class="d-flex h3 mb-0 mw-0">
      <div v-if="timetableActivated" class="mr-3 position-relative mw-0 d-flex">
        <b-button
          :class="{ 'text-muted': !isTimetableView }"
          class="reset-button mb-2 black font-weight-bolder tt-header-btn text-truncate"
          variant="link"
          data-cy="open-timetable"
          @click="$router.push({ name: 'timetable-middle' })"
        >
          {{ $t('global.headers.timetable') }}
        </b-button>
        <div v-if="isTimetableView"
             data-cy="tt-active-indicator"
             class="path-active w-100 position-absolute bottom-0 start-0"
        />
      </div>

      <div class="position-relative mw-0">
        <div class="d-flex align-items-start">
          <b-button
            :class="{ 'text-muted': !isCalendarView }"
            class="reset-button mb-2 black font-weight-bolder tt-header-btn text-truncate"
            variant="link"
            data-cy="open-calendar"
            @click="$router.push(routerParams)"
          >
            {{ $t('calendar.title') }}
          </b-button>
        </div>
        <div v-if="isCalendarView"
             data-cy="calendar-active-indicator"
             class="path-active w-100 position-absolute bottom-0 start-0"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimetableGeneralHeaderLeft',
  props: {
    isTimetableView: {
      type: Boolean,
      required: true,
    },

    isCalendarView: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    routerParams() {
      const viewType = window.localStorage?.getItem('calendar_view_type')
      return viewType === 'list'
        ? { name: 'calendar-list' }
        : {
          name: 'calendar-grid',
          params: {
            id: this.$me?.id,
          },

          query: { viewType },
        }
    },

    timetableActivated() {
      return this.$me?.school.meta.footer_menu.includes('timetable')
    },
  },
}
</script>

<style scoped lang="scss">
.path-active {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%), $color-primary;
  background-blend-mode: soft-light, normal;
  border-radius: 1px;
  height: 2px;
}

.tt-header-btn {
  /* stylelint-disable-next-line declaration-property-value-allowed-list */
  font-size: min(1.25rem, 36px) !important;
  line-height: pxtorem(24);
  &:hover {
    color: $color-black !important;
  }
}
</style>
